import styled from 'styled-components';

import Heading from '../Heading/Heading.styled';

export const SectionTitleStyled = styled(Heading).attrs(({ level }) => ({
  ...(level ? { level } : { level: 3 }),
}))`
  margin-bottom: 15px;

  ${({ theme }) => `
    color: ${theme.primaryColour};
  `}
`;
